import { BASEURL } from '../../Constants';

export async function resetPassword(password, confirmPassword, token) {
  if (password !== confirmPassword) {
    alert('Passwords do not match');
    return { success: false };
  }

  try {
    const response = await fetch(`${BASEURL}/user/forgot-password/reset`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token,
        password,
        confirm_password: confirmPassword,
      }),
    });

    const result = await response.json();
    return result;

  } 
  catch (error) {
    console.error('Error resetting password:', error);
    return { success: false, message: 'An error occurred. Please try again.' };
  }
}


export async function SendForgotPasswordLink(email) {
  

  try {
    const response = await fetch(`${BASEURL}/user/forgot-password/link`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email
      }),
    });

    const result = await response.json();
    return result;

  } catch (error) {
    return { success: false, message: 'An error occurred. Please try again.' };
  }
}